import TextPopup from './TextPopup';

export default TextPopup;
